"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppFeatureTogglesDto = void 0;
const swagger_1 = require("@nestjs/swagger");
/** Feature Flags kill switches (see `AppFeature`), as exposed on `/me`. Off = hide the feature. */
class AppFeatureTogglesDto {}
exports.AppFeatureTogglesDto = AppFeatureTogglesDto;
__decorate([(0, swagger_1.ApiProperty)({
  description: 'New app UI (MapScreen) for everyone; false = the old UI.'
}), __metadata("design:type", Boolean)], AppFeatureTogglesDto.prototype, "mapUi", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Square Tickets: in-app purchases, Square tickets in My Tickets and refund requests.'
}), __metadata("design:type", Boolean)], AppFeatureTogglesDto.prototype, "payments", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], AppFeatureTogglesDto.prototype, "stickers", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Eventbrite import on the admin event form.'
}), __metadata("design:type", Boolean)], AppFeatureTogglesDto.prototype, "eventbrite", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Eventbrite Tickets: connecting Eventbrite in Connected accounts and its tickets in the app.'
}), __metadata("design:type", Boolean)], AppFeatureTogglesDto.prototype, "eventbriteTickets", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], AppFeatureTogglesDto.prototype, "autoCheckIns", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'User-density hotspots and partnered hotspots.'
}), __metadata("design:type", Boolean)], AppFeatureTogglesDto.prototype, "hotspots", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Google sign in / sign up / account linking in the app.'
}), __metadata("design:type", Boolean)], AppFeatureTogglesDto.prototype, "googleAuth", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Profile photo verification; false = photos are saved unverified, without a check.'
}), __metadata("design:type", Boolean)], AppFeatureTogglesDto.prototype, "photoVerification", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'The new map\'s "Check In" button next to the recenter button.'
}), __metadata("design:type", Boolean)], AppFeatureTogglesDto.prototype, "checkInButton", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Settings > Connected accounts (link Google / Apple, plus Eventbrite while Eventbrite Tickets is on). Off: the row is hidden in the app.'
}), __metadata("design:type", Boolean)], AppFeatureTogglesDto.prototype, "connectedAccounts", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'The "Sync to Google Calendar" switch on My Plans. Off: the switch is hidden in the app.'
}), __metadata("design:type", Boolean)], AppFeatureTogglesDto.prototype, "calendarSync", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Settings > My Tickets (also needs Square Tickets or Eventbrite Tickets on). Off: the row is hidden in the app.'
}), __metadata("design:type", Boolean)], AppFeatureTogglesDto.prototype, "myTickets", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Settings > Notifications: "Vibrate on notifications" and the vibration pattern. Off: the section is hidden in the app.'
}), __metadata("design:type", Boolean)], AppFeatureTogglesDto.prototype, "vibrations", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'The My Plans tab in the new app\'s bottom bar. Off: the tab is hidden.'
}), __metadata("design:type", Boolean)], AppFeatureTogglesDto.prototype, "myPlansTab", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Map "My Places List" and "Footprint List" buttons in their filter colors. Off: black buttons.'
}), __metadata("design:type", Boolean)], AppFeatureTogglesDto.prototype, "coloredListButtons", void 0);
//# sourceMappingURL=AppFeatureToggles.dto.js.map